import type { ICatalog, IMe } from '@platform/core/types';
import { defaultPins } from '@platform/navigation';
import { createdWorkspace } from './createdWorkspace';

/**
 * Закріплені модулі робочого простору (прототип v4 pins[ws]): вибір користувача (налаштування pinnedModules[ws]); доки нічого не
 * закріплено — автозакріплення прототипу (crmPinned, kbPinned): у просторі з CRM чи базою знань — основні модулі в порядку простору
 * (Справи, Завдання, База знань, CRM); без них — нічого (зірки «Усіх модулів» порожні, кнопки закріплених у верхній панелі немає).
 * Простір, створений користувачем, автозакріплення не має (createdWorkspace: закріплено вибране під час створення). Лише встановлені
 * модулі. Головна показує замість порожнього переліку основні модулі — homePinnedKeys.
 */
export function pinnedKeys(me: IMe | undefined, catalog: ICatalog | undefined, ws: string): string[] {
  const installed = new Set((catalog?.modules ?? []).filter((m) => m.installed).map((m) => m.key));
  const chosen = me?.pinnedModules[ws] ?? [];
  if (chosen.length) return chosen.filter((k) => installed.has(k));
  if (createdWorkspace(me, ws)) return [];
  const defaults = defaultPins().length ? defaultPins() : (catalog?.modules ?? []).filter((m) => m.core).map((m) => m.key);
  return installed.has('crm') || installed.has('kb') ? defaults.filter((k) => installed.has(k)) : [];
}
